import React from 'react';
import { ReactSVG } from 'react-svg';
import styles from './styles.module.css';

const AddButton = ({ onClick, icon, title }) => {
  return (
    <button
      className={styles.addButton}
      onClick={() => {
        onClick();
      }}>
      <span className={styles.addButtonPlus}>+</span>
      {title && <span>{title}</span>}
      {icon && <ReactSVG src={icon} />}
    </button>
  );
};

export default AddButton;
